import QuestionModel from "./QuestionModel";

export default class QuestionModelChart extends QuestionModel {
    constructor(module, type, view, input, range) {
        super(module, type, view, input, range);

        this._answer = null;
        this.templateType = "";
        this.labelKey = null;
        this.labelIndex = -1;
        this.answerIndex = -1;
    }

    set answer(value) {
        this._answer = value;
    }

    get answer() {
        return this._answer;
    }
}